
function checkCount(count, prev, next, limit) {
  if (count === 0) {
    prev.classList.add('disable-nav')
  } else {
    prev.classList.remove('disable-nav')
  }
  if (count === limit) {
    next.classList.add('disable-nav')
  } else {
    next.classList.remove('disable-nav')
  }
}

export const blogAthlete = () => {

  const parent = document.querySelector('.featured-slider-controls');
  const slides = document.querySelectorAll('.blog-featured-athlete-hero-snippet');
  const prev = document.querySelector('.control-arrows .previous');
  const next = document.querySelector('.control-arrows .next');
  const activeSlide = document.querySelector('[data-featured-update]');

  let count = 0;

  const limit = slides.length - 1
 
  if (parent) {
    prev.addEventListener('click', () => {
      slides[count - 1].classList.add('featured-active');
      slides[count].classList.remove('featured-active')
      count--;
      activeSlide.innerHTML = '0' + (count + 1)
      checkCount(count, prev, next, limit);
    })
    
    next.addEventListener('click', () => {
      slides[count + 1].classList.add('featured-active');
      slides[count].classList.remove('featured-active')
      count++;
      activeSlide.innerHTML = '0' + (count + 1)
      checkCount(count, prev, next, limit);
    })
  }
}

export const ambassadorShowMore = () => {
  const showMoreBtn = document.querySelector('.see-more-btn button');
  const ambassadors = [...document.querySelectorAll('.ambassadors-grid .images-excerpt')].filter(item => window.getComputedStyle(item).getPropertyValue('display') === 'none');

  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', () => {
      ambassadors.forEach(item => item.style.cssText = 'display: flex; opacity: 1');
      showMoreBtn.style.display = 'none'
    })
  }
}
